import classnames from 'classnames';
import Dimmer from 'mcs-toolkit/components/Dimmer';
import Spinner from 'mcs-toolkit/components/Loader';
import React, { PureComponent } from 'react';

import css from './Loader.css';

export class Loader extends PureComponent {
    renderStickySpinner(spinner) {
        return (
            <div className={css.stickyLayout}>
                <div className={css.spinnerWrapper}>{spinner}</div>
            </div>
        );
    }

    render() {
        const {
            transparent = false,
            fullPage = false,
            opaque = false,
            className = '',
            ...restProps
        } = this.props;

        const spinner = <Spinner inverted />;

        return (
            <Dimmer
                inverted
                active={true}
                className={classnames(
                    css.root,
                    {
                        [css.fullPage]: fullPage,
                        [css.opaque]: opaque,
                        [css.transparent]: transparent,
                    },
                    className,
                )}
                {...restProps}
            >
                {fullPage ? this.renderStickySpinner(spinner) : spinner}
            </Dimmer>
        );
    }
}

export default Loader;
